"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = exports.calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator = void 0;
/* eslint-disable camelcase */
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const NUMERATOR_FIELD = 'installment_balances';
// this method uses given baseField as numerator (instead of exposure) to caluclate concentration limit kickouts
const calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator = ({ concentrationReceivables, totalConcentrationExposure, concentrationLimit, concentrationLimitValueType, field, }) => {
    const normalizedConcentrationLimit = (0, calc_agent_1.getNormalizedConcentrationLimit)({
        concentrationLimit,
        concentrationLimitValueType,
        totalConcentrationExposure,
    });
    let concentrationAmount = 0;
    concentrationReceivables.forEach((rec) => {
        const value = rec.baseFields[field];
        (0, common_1.finleyAssert)(typeof value === 'number', `calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator: baseFields.${field} must be a number. Found [${rec.baseFields[field]}}]`);
        if (rec.eligibilityFields.isEligible) {
            concentrationAmount += value;
        }
    });
    const exposureLimit = _.round(totalConcentrationExposure * normalizedConcentrationLimit, 10);
    // We'll multiply each loanTape by the concentration factor to get the
    // updated borrowing base amount
    const concentrationFactor = Math.max(concentrationAmount - exposureLimit, 0) > 0
        ? 1 - common_1.utils.divideByOrZero(exposureLimit, concentrationAmount)
        : 0;
    const kickouts = (0, calc_agent_1.getConcentrationLimitKickouts)({
        concentrationFactor,
        concentrationReceivables,
    });
    return {
        kickouts,
        calculations: {
            concentrationAmount,
            concentrationLimit: normalizedConcentrationLimit,
            concentration: _.round(common_1.utils.divideByOrZero(concentrationAmount, totalConcentrationExposure), 10),
        },
    };
};
exports.calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator = calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator;
/*
so essentially there are some receivables that are "installment loans" where a portion of the exposure  is made up of installmentBalances . The concentration limit is expected to identify the loans that have installmentBalances > 0, and sum these up to be the numerator of the concentration limit test. Typically, the tests are set up to identify these receivables and sum up the full exposure for the numerator, but here we are only looking to have a portion of the exposure as the numerator in the test
*/
exports.concentrationLimitPointerMethods = [
    // any single receivable cannot be more than 20%
    {
        method: 'brimFinancialAtlasSp1.installmentPayAccountsUpTo5Percent',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit singleReceivableLimit`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            const result = (0, exports.calculateStandardConcentrationLimitKickoutsForCustomBaseFieldNumerator)({
                concentrationReceivables,
                totalConcentrationExposure,
                concentrationLimit,
                concentrationLimitValueType,
                field: NUMERATOR_FIELD,
            });
            return result;
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map